export const ACCOUNT_REGISTRATION_BEGIN = 'ACCOUNT_REGISTRATION_BEGIN';
export const ACCOUNT_REGISTRATION_FAIL = 'ACCOUNT_REGISTRATION_FAIL';
export const ACCOUNT_REGISTRATION_SUCCESS = 'ACCOUNT_REGISTRATION_SUCCESS';
